import { render } from "./FilterAtbusinessFunction.vue?vue&type=template&id=5c2d3546"
import script from "./FilterAtbusinessFunction.vue?vue&type=script&lang=js"
export * from "./FilterAtbusinessFunction.vue?vue&type=script&lang=js"
script.render = render

export default script